/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'bid': {
    width: 16,
    height: 16,
    viewBox: '0 0 30 31',
    data: '<path pid="0" fill-rule="evenodd" d="M15.6 29a1 1 0 110 2h-14a1 1 0 010-2h14zM3.9 13.1l8.34 3.37a1.5 1.5 0 01.83 1.95l-1.5 3.71a1.5 1.5 0 01-1.95.83L1.27 19.6a1.5 1.5 0 01-.83-1.95l1.5-3.71a1.5 1.5 0 011.95-.83zm-.29 2.04l-1.12 2.78 7.42 3 1.12-2.78-7.42-3zM4.92 9.2l24.1 9.74a1 1 0 01-.74 1.86l-24.1-9.74a1 1 0 01.74-1.86zm3.84-8.15l8.34 3.37a1.5 1.5 0 01.83 1.95l-1.5 3.7a1.5 1.5 0 01-1.95.84L6.13 7.54a1.5 1.5 0 01-.82-1.96l1.5-3.7a1.5 1.5 0 011.95-.83zm-.29 2.04L7.35 5.87l7.42 3 1.12-2.79-7.42-3z"/>'
  }
})
